var path = 'C:/Projects/repos/NAERS-Web/src/components/app/reports/admin-trend/admin-trend.html';
var html = "<div layout=column> <report-form on-report-generated=$ctrl.generateReport($event)> </report-form> <highchart class=naers-report config=$ctrl.chartConfig ng-if=\"$ctrl.chartConfig && $ctrl.chartConfig.series\" style=overflow:hidden> </highchart> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./components/app/reports/admin-trend/admin-trend.html
// module id = 709
// module chunks = 0